<template>
  <div>
    <article class="template-page-tile">
      <div>
        <div class="is-flex is-justify-content-space-between">
          <label class="label">Tags</label>
          <span class="button is-small is-primary is-light tooltip"
            :class="`is-light-btn-${$theme.name}`"
            @click="toggleManageTagsModal"
            data-tooltip="Manage Tags">
            <i class="icon mdi mdi-plus mdi-24px" />
          </span>
        </div>
        <div class="tags-scroll-container">
          <div v-for="tag in tags"
            :key="tag.tagID"
            @click="toggleTag(tag)"
            style="cursor: pointer">
            <div class="is-flex is-align-items-center p-2">
              <span class="tag-short mr-2"
                :style="{ backgroundColor: tag.colorHex, color: getTextColor(tag.colorHex) }">{{ tag.shortTag }}</span>
              <span class="mr-auto">{{ tag.tagName }}</span>
              <div class="pretty p-icon p-curve p-smooth p-bigger m-0 ml-2">
                <input type="checkbox"
                  :checked="selectedTags.includes(tag.tagID)"
                  @change.stop="toggleTag(tag)"
                  @click.stop
                  style="cursor: pointer">
                <div class="state p-primary"
                  @click.stop="toggleTag(tag)"
                  style="cursor: pointer">
                  <i class="icon mdi mdi-check" />
                  <label />
                </div>
              </div>
            </div>
            <hr class="m-0">
          </div>
        </div>
      </div>
    </article>
    <manage-tags-modal v-if="true"
      :active="showManageTagsModal"
      :tags="tags"
      :tag-category-id="tagCategoryId"
      @close="showManageTagsModal = false"
      @save="handleSaveTags" />
  </div>
</template>

<script>
import { getTextColor } from '../../utils/ColorFunctions'
import ManageTagsModal from '../manageTag/ManageTagsModal.vue'
import { EventHubTypes } from '../../enums'

export default {
  name: 'QuoteTemplateTags',
  components: {
    ManageTagsModal
  },
  props: {
    tags: {
      type: Array,
      required: true
    },
    selectedTags: {
      type: Array,
      required: true
    },
    tagCategoryId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      showManageTagsModal: false
    }
  },
  methods: {
    getTextColor,
    toggleTag(tag) {
      this.$emit('toggle-tag', tag)
    },
    handleSaveTags(tags) {
      this.$eventHub.$emit(EventHubTypes.ReloadQuoteTemplate)
    },
    toggleManageTagsModal() {
      this.showManageTagsModal = !this.showManageTagsModal
    }
  }
}
</script>

<style lang="scss" scoped>
.tags-scroll-container {
  max-height: 400px;
  overflow-y: auto;
  margin-top: 8px;

  // Custom scrollbar styling for webkit browsers
  // &::-webkit-scrollbar {
  //   width: 8px;
  // }

  // &::-webkit-scrollbar-track {
  //   background: #f5f5f5;
  //   border-radius: 4px;
  // }

  // &::-webkit-scrollbar-thumb {
  //   background: #c1c1c1;
  //   border-radius: 4px;

  //   &:hover {
  //     background: #a8a8a8;
  //   }
  // }

  // Firefox scrollbar styling
  // scrollbar-width: thin;
  // scrollbar-color: #c1c1c1 #f5f5f5;
}

// Responsive adjustments
// @media (max-height: 600px) {
//   .tags-scroll-container {
//     max-height: 300px;
//   }
// }

// @media (max-height: 400px) {
//   .tags-scroll-container {
//     max-height: 250px;
//   }
// }

// Hover effects for better UX
// .tags-scroll-container > div:hover {
  // background-color: #f8f9fa;
  // transition: background-color 0.2s ease;
// }

// Ensure proper spacing
.template-page-tile {
  .label {
    margin-bottom: 0.5rem;
  }
}
</style>
